import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { Wrapper as Icon } from 'components/shared/Icon/styles'

import { resolveResponsiveProp } from 'styles/mixins'

interface ExpandProps {
    isOpened: boolean
    maxHeight: number | [number, number]
}
export const ExpandBox = styled(Box)<ExpandProps>`
    overflow: hidden;
    transition: max-height 200ms ease-in;

    ${({ isOpened, maxHeight }) =>
        resolveResponsiveProp({
            type: 'max-height',
            value: isOpened ? maxHeight : 0,
            unit: 'px',
        })}

    & > * {
        opacity: ${({ isOpened }) => (isOpened ? 1 : 0)};
        transition: opacity 100ms ease-in
            ${({ isOpened }) => (isOpened ? '200ms' : 0)};
    }
`
export const ExpandButton = styled(Box)`
    cursor: pointer;
    user-select: none;

    &:focus-visible {
        ${Text}, ${Icon} {
            color: ${({ theme }) => theme.colors.primary_500} !important;
        }
    }
`
